import { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

function Profil() {
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const [ancienMotDePasse, setAncienMotDePasse] = useState("");
  const [nouveauMotDePasse, setNouveauMotDePasse] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const roleLabel = {
    super_admin: "Super administrateur",
    admin_fete: "Administrateur Fête",
    admin_oumrah: "Administrateur Oumrah",
    directeur: "Directeur",
  };

  const handleSubmit = async () => {
    setError(""); setSuccess("");
    if (!ancienMotDePasse || !nouveauMotDePasse) {
      setError("Merci de remplir tous les champs.");
      return;
    }
    if (nouveauMotDePasse.length < 6) {
      setError("Le nouveau mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (nouveauMotDePasse !== confirmation) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      await api.put("/auth/changer-mot-de-passe", {
        ancien_mot_de_passe: ancienMotDePasse,
        nouveau_mot_de_passe: nouveauMotDePasse,
      });
      setSuccess("Mot de passe modifié avec succès.");
      setAncienMotDePasse(""); setNouveauMotDePasse(""); setConfirmation("");
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={7}>
            <Card sx={{ p: 3, mb: 3 }}>
              <MDTypography variant="h5" mb={2}>Mon profil</MDTypography>
              {user && (
                <MDBox display="flex" flexDirection="column" gap={0.5}>
                  <MDTypography variant="button" color="text"><strong>Nom :</strong> {user.nom}</MDTypography>
                  <MDTypography variant="button" color="text"><strong>Email :</strong> {user.email}</MDTypography>
                  {user.ville && (
                    <MDTypography variant="button" color="text"><strong>Ville :</strong> {user.ville}</MDTypography>
                  )}
                  <MDTypography variant="button" color="text"><strong>Rôle :</strong> {roleLabel[user.role] || user.role}</MDTypography>
                </MDBox>
              )}
            </Card>

            <Card sx={{ p: 3 }}>
              <MDTypography variant="h6" mb={2}>Changer mon mot de passe</MDTypography>
              <Divider sx={{ mb: 2 }} />
              <MDBox display="flex" flexDirection="column" gap={2} maxWidth={400}>
                <TextField
                  label="Mot de passe actuel"
                  type="password"
                  fullWidth
                  value={ancienMotDePasse}
                  onChange={(e) => setAncienMotDePasse(e.target.value)}
                />
                <TextField
                  label="Nouveau mot de passe"
                  type="password"
                  fullWidth
                  value={nouveauMotDePasse}
                  onChange={(e) => setNouveauMotDePasse(e.target.value)}
                />
                <TextField
                  label="Confirmer le nouveau mot de passe"
                  type="password"
                  fullWidth
                  value={confirmation}
                  onChange={(e) => setConfirmation(e.target.value)}
                />
                {error && (
                  <MDTypography variant="caption" color="error">{error}</MDTypography>
                )}
                {success && (
                  <MDTypography variant="caption" sx={{ color: "#43a047" }}>{success}</MDTypography>
                )}
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={handleSubmit}
                  disabled={submitting}
                  sx={{ alignSelf: "flex-start" }}
                >
                  {submitting ? "Enregistrement..." : "Changer le mot de passe"}
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Profil;
